import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetAll } from '../../service/EpinPurchaseService';

export default function EpinPurchaseList() {
  const {
    isLoading, setIsLoading,
    setAppError, setAppErrorTitle, setAppErrorMessage, setAppErrorMode
  } = useGlobalContext();

  const [epinPurchases, setEpinPurchases] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const fetchEpinPurchaseList = async (currentPage = page) => {
    try {
      setIsLoading(true);
      const response = await GetAll(currentPage, limit, keyword);
      setEpinPurchases(response.epinPurchases || []);
      setTotalPages(response.totalPages || 1);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEpinPurchaseList(page);
  }, [page]);

  const handleSearch = () => {
    setPage(1);
    fetchEpinPurchaseList(1);
  };

  return (
    <>
      <Helmet>
        <title>Epin Purchase List | {config.appName}</title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>Epin Purchase List</h1>
            <span><Link to="/"> Dashboard </Link> / Epin Purchase List</span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <form>
                  <div className='row'>
                    <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Keyword</label>
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            className="form-control"
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                          />
                          <button className="btn btn-outline-secondary" type="button" onClick={handleSearch}>
                            <FontAwesomeIcon icon="fa-solid fa-search" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-4 col-md-3 col-sm-6 col-12'>
                      <div className="p-2">
                        <div className="input-group p-4">
                          <Link className="btn btn-success" to="/epinpurchase/add">
                            <FontAwesomeIcon icon="fa-solid fa-plus" /> Add Epin Purchase
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <div className='table-content'>
                  <div className="mobile-scroll">
                  <table className='table table-bordered table-condensed'>
                    <thead>
                      <tr>
                        <th>Sl.no</th>
                        <th>Purchase date</th>
                        <th>Price</th>
                        <th>Unit</th>
                        <th>Level</th>
                        <th>Member Name</th>
                        <th>Remarks</th>
                        <th>Total</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {epinPurchases && epinPurchases.length > 0 ? (
                        epinPurchases.map(({ epinPurchase, total }, index) => (
                          <tr key={epinPurchase.id}>
                            <td>{(page - 1) * limit + index + 1}</td>
                            <td>
                              {epinPurchase.purchaseDate?.date && (() => {
                                const date = new Date(epinPurchase.purchaseDate.date);
                                const day = String(date.getDate()).padStart(2, '0');
                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                const year = date.getFullYear();
                                return `${day}-${month}-${year}`;
                              })()}
                            </td>
                            <td>{epinPurchase.price}</td>
                            <td>{epinPurchase.unit}</td>
                            <td>{epinPurchase.level?.name ?? ''}</td>
                            <td>{epinPurchase.user?.name ?? ''}</td>
                            <td>{epinPurchase.remarks}</td>
                            <td>{total}</td>
                            <td>{epinPurchase.status}</td>
                            <td>
                              <Link to={`/epin/list/${epinPurchase.id}`} className='btn btn-sm btn-warning' title="View Epin">
                                <FontAwesomeIcon icon="fa-solid fa-eye" />
                              </Link>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr><td colSpan="10" className="text-center">No purchases found</td></tr>
                      )}
                    </tbody>
                  </table>
                  </div>
                </div>

                {/* Pagination Controls */}
                <div className="pagination-buttons">
                  {page > 1 && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                    >
                      Prev
                    </button>
                  )}

                  <span className="align-self-center px-3">Page {page} of {totalPages}</span>

                  {page < totalPages && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
